/**
 * @file Created on Thu Nov 29 2018
 * @author PKl
 */
import BoxStatusStyled from './styled/BoxStatusStyled';
import * as React from 'react';
export var BoxStatus = function BoxStatus(props) {
  return React.createElement(BoxStatusStyled, Object.assign({}, props));
};